const toggleMaterialEducatorOnly = (state) => {
  const { isMaterialEducatorOnlyExpanded } = state;
  return {
    ...state,
    isMaterialEducatorOnlyExpanded: !isMaterialEducatorOnlyExpanded,
  };
};

export default toggleMaterialEducatorOnly;
